module.exports = __webpack_public_path__ + "static/media/oaks.5b3bfbef.jpg";